var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-element columns is-gapless is-centered"},[_c('div',{staticClass:"colum"},[_c('figure',{staticClass:"image"},[_c('LazyLoadedImage',{staticClass:" ",attrs:{"src":_vm.imgSrc,"alt":"Hero Banner"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }